<div class="h-full" fxLayout="row">
  <main class="main" fxFlex="none">
    <router-outlet></router-outlet>
  </main>
  <main class="details" [ngClass]="{ 'details--shrink': sidebar.isActivated }">
    <router-outlet name="details"></router-outlet>
  </main>
  <main
    class="sidebar"
    [ngClass]="{ 'sidebar--open': sidebar.isActivated }"
    fxFlex="noshrink"
  >
    <div class="sidebar__content">
      <router-outlet name="sidebar" #sidebar="outlet"></router-outlet>
    </div>
  </main>
</div>
